import { render } from "./Default.layout.vue?vue&type=template&id=739ecc76"
import script from "./Default.layout.vue?vue&type=script&lang=js"
export * from "./Default.layout.vue?vue&type=script&lang=js"

import exportComponent from "/builds/ASIP-Sante/g1/shared/santefr/web/modules/custom/sante_vuejs/vue-core/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/layouts/Default.layout.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "739ecc76"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('739ecc76', __exports__)) {
    console.log('reload')
    api.reload('739ecc76', __exports__)
  }
  
  module.hot.accept("./Default.layout.vue?vue&type=template&id=739ecc76", () => {
    console.log('re-render')
    api.rerender('739ecc76', render)
  })

}


export default __exports__